import colors from 'styles/theme/colors';

export default function NetworkProviderIcon({
  width = 13,
  height = 13,
  color = colors.black50,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0.5 2.24805C0.776066 2.24805 0.999877 2.47201 1 2.74805V5.24512H2.74805C3.85166 5.2452 4.74591 6.14056 4.74609 7.24414V7.49316H11.7393C12.0153 7.49316 12.2392 7.71711 12.2393 7.99316V11.7393C12.2393 12.0154 12.0154 12.2393 11.7393 12.2393C11.4634 12.2389 11.2393 12.0152 11.2393 11.7393V10.7412H1V11.7393C1 12.0154 0.776142 12.2393 0.5 12.2393C0.224036 12.239 0 12.0153 0 11.7393V2.74805C0.000123119 2.47214 0.224112 2.24826 0.5 2.24805ZM1 9.74121H11.2393V8.49316H1V9.74121ZM1 7.49316H3.74609V7.24414C3.74591 6.69284 3.29937 6.2452 2.74805 6.24512H1V7.49316ZM7.24414 0C7.52012 4.34942e-05 7.74394 0.224059 7.74414 0.5V2.24805H9.49219C9.76811 2.24821 9.99206 2.47211 9.99219 2.74805C9.99219 3.02409 9.76819 3.24788 9.49219 3.24805H7.74414V4.99609C7.74397 5.27207 7.52014 5.49605 7.24414 5.49609C6.9681 5.49609 6.74431 5.27209 6.74414 4.99609V3.24805H4.99609C4.71999 3.248 4.49609 3.02416 4.49609 2.74805C4.49622 2.47204 4.72007 2.24809 4.99609 2.24805H6.74414V0.5C6.74435 0.224033 6.96813 0 7.24414 0Z'
        fill={color}
      />
    </svg>
  );
}
